/* eslint-disable */
// prettier-ignore-start
import { Container, Row, Col } from 'react-bootstrap';
import { litrals } from '../../../../../../../constants/Litrals';
import SmallInfoCard from '../../../../molecules/SmallInfoCard';
import { breadcrumbsLinks } from '../../../../../../../constants/Constants';
import Breadcrumbs from '../../../../../../ntisui/Atoms/Breadcrumb';

const Feedback = () => {
  const handleMailTo = () => {
    window.location.href = 'mailto:NTISSubscriberHelpline@soprasteria.com';
  };

  return (
    <Container className="subscriber-container">
      <Breadcrumbs links={breadcrumbsLinks.contact} />
      <Row>
        <Col xs={12} md={6} className="card-container-new">
          <h3 data-testid="feedback" className="feedback-heading">
            {litrals.subscriberContactUS}
          </h3>
          <div className="subscriber-content">
            <SmallInfoCard
              contentbeforelink={litrals.requireFurtherAssistance}
              clickHere={"NTIS Technical Authority"}
              contentafterlink={''}
              onClick={handleMailTo}
            />
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default Feedback;
